import { createTypes, createAction } from 'lib/action'
const LOAD_EXCESS_EXPENSES = createTypes('loadexcessexpenses', 'load')
const LOAD_EXCESS_EXPENSES_DETAIL = createTypes('loadexcessexpensesdetail', 'load')
const CREATE_EXCESS_EXPENSES = createTypes('createexcessexpenses', 'create')
const UPDATE_EXCESS_EXPENSES = createTypes('updateexcessexpenses', 'update')
const EXPORT_EXCESS_EXPENSES = createTypes(
  'exportexcessexpensesdetail',
  'load',
)
const REMOVE_LISTS = `REMOVE_LISTS`

function removeLists() {
  return {
    type: REMOVE_LISTS,
  }
}

const loadExcessExpenses = {
    request: (data, loading) =>
      createAction(LOAD_EXCESS_EXPENSES.REQUEST, { data, loading }),
    success: (lists, page) =>
      createAction(LOAD_EXCESS_EXPENSES.SUCCESS, { lists, page }),
    failure: () => createAction(LOAD_EXCESS_EXPENSES.FAITLURE),
}

const loadExcessExpensesDetail = {
    request: (data, loading) =>
      createAction(LOAD_EXCESS_EXPENSES_DETAIL.REQUEST, { data, loading }),
    success: listDetail => createAction(LOAD_EXCESS_EXPENSES_DETAIL.SUCCESS, { listDetail }),
    failure: () => createAction(LOAD_EXCESS_EXPENSES_DETAIL.FAITLURE),
}

const exportExcessExpenses = {
  request: (data, loading) =>
    createAction(EXPORT_EXCESS_EXPENSES.REQUEST, { data, loading }),
  success: (lists, page) =>
    createAction(EXPORT_EXCESS_EXPENSES.SUCCESS, { lists }),
  failure: () => createAction(EXPORT_EXCESS_EXPENSES.FAITLURE),
}

const createExcessExpenses = {
  request: (data, loading) =>
    createAction(CREATE_EXCESS_EXPENSES.REQUEST, { data, loading }),
  success: res => createAction(CREATE_EXCESS_EXPENSES.SUCCESS, { res }),
  failure: () => createAction(CREATE_EXCESS_EXPENSES.FAITLURE),
}

const updateExcessExpenses = {
  request: (data, loading) =>
    createAction(UPDATE_EXCESS_EXPENSES.REQUEST, { data, loading }),
  success: res => createAction(UPDATE_EXCESS_EXPENSES.SUCCESS, { res }),
  failure: () => createAction(UPDATE_EXCESS_EXPENSES.FAITLURE),
}


export {
    REMOVE_LISTS,
    removeLists,
    LOAD_EXCESS_EXPENSES,
    loadExcessExpenses,
    LOAD_EXCESS_EXPENSES_DETAIL,
    loadExcessExpensesDetail,
    UPDATE_EXCESS_EXPENSES,
    updateExcessExpenses,
    CREATE_EXCESS_EXPENSES,
    createExcessExpenses,
    EXPORT_EXCESS_EXPENSES,
    exportExcessExpenses
}